import React, { useState } from "react";
import SectionContainer from "../../../Homepage/SectionContainer";
import calendar from "../../../assets/kangaroo/calendar.png";
import clock from "../../../assets/kangaroo/clock.png";
import location from "../..//../assets/kangaroo/location.png";
import phone from "../../../assets/kangaroo/phone.png";
import { Link, useParams } from "react-router-dom";
import { Col, Container, Row } from "reactstrap";
import MediumButton from "../../../component/button/MediumButton";
import Map from "../../../Homepage/Map";
import SmallPage from "../../../Homepage/SmallPage";
import Form from "../../../component/Form/Form";
import BreadCrumb from "../../../component/BreadCrumb/BreadCrumb";
import EventService from "../../../services/EventService";
import { useQuery } from "@tanstack/react-query";
import { imageBaseApi } from "../../../services/imageBaseApi";
import "../event.css";
import { formatDate } from "../../../common/formatedate";
const EventDetail = () => {
  const { eventID } = useParams();
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768)

  const fetchData = async (id) => {
    const response = await EventService.getBySlug(id);
    console.log(response);
    return response;
  };

  const {
    isPending,
    error,
    data: eventData,
  } = useQuery({
    queryKey: ["eventData", eventID],
    queryFn: () => fetchData(eventID),
  });

  const [modalOpen, setModalOpen] = useState(false);
  const toggleModal = () => setModalOpen(!modalOpen);
  if (isPending) return <div>Loading...</div>;
  if (error) return <div>Error: {error.message}</div>;

  const handleButton = () => {
    toggleModal();
  };
  return (
    <>
      <SectionContainer>
        <Container>
          <BreadCrumb
            items={[
              { title: "HOME", link: "/" },
              { title: "EVENTS", link: "/events" },
              { title: "DETAIL" },
            ]}
            instituition={false}
          />
          <Row>
            <Col
              style={{ height: "355px", width: "100%", overflow: "hidden" }}
              className="rounded-5"
            >
              <img
                src={
                  imageBaseApi +
                  (isMobile
                    ? eventData?.thumbnailMedia?.url || eventData?.bannerMedia?.url
                    : eventData?.bannerMedia?.url)
                }
                className="w-100 h-100 rounded-5"
                alt=""
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                  objectPosition: isMobile ? "left center" : "center",
                }}
              />

            </Col>
          </Row>
          <h1 className="career-sub-heading my-4">{eventData?.name}</h1>
          <Row>
            <Col>
              <p className="country-paragraph-text">{eventData?.description}</p>
            </Col>
          </Row>
          <div style={{ marginTop: "33px" }}>
            <div>
              {eventData?.eventsCities?.map((cityItem, index) => (
                <div>
                  <p className="event-city">
                    City:{" "}
                    <span className="event-city fw-bold">{cityItem?.city}</span>
                  </p>

                  <Row className="mb-2 align-items-center">
                    <Col className="d-flex align-items-center gap-2">
                      <img
                        src={calendar}
                        alt="icon"
                        style={{ width: "24px", height: "24px" }}
                      />
                      <p className="country-paragraph-text mb-0">
                        {formatDate(cityItem?.eventDate)}
                      </p>
                    </Col>
                  </Row>

                  <Row className="mb-2 align-items-center">
                    <Col className="d-flex align-items-center gap-2">
                      <img
                        src={clock}
                        alt="icon"
                        style={{ width: "24px", height: "24px" }}
                      />
                      <p className="country-paragraph-text mb-0">
                        {cityItem?.timeRange}
                      </p>
                    </Col>
                  </Row>

                  <Row className="mb-2 align-items-center">
                    <Col className="d-flex align-items-center gap-2">
                      <img
                        src={location}
                        alt="icon"
                        style={{ width: "20px", height: "auto" }}
                      />
                      <p className="country-paragraph-text mb-0">
                        {cityItem?.location}
                      </p>
                    </Col>
                  </Row>

                  <Row className="mb-2 align-items-center">
                    <Col className="d-flex align-items-center gap-2">
                      <img
                        src={phone}
                        alt="icon"
                        style={{ width: "24px", height: "24px" }}
                      />
                      <p className="country-paragraph-text mb-0 fw-bold">
                        {cityItem?.phoneNumber}
                      </p>
                    </Col>
                  </Row>
                </div>
              ))}

              {/* Hide hr for last item */}

              <hr
                className="my-4"
                style={{ borderTop: "1.5px solid #5c5858" }}
              />
            </div>
          </div>
          {eventData?.registrationRequired ? (
            <Link
              to={eventData?.registrationUrl}
              target="_blank" // remove if you want same tab
              rel="noopener noreferrer"
              style={{ textDecoration: "none" }}
            >
              <div style={{ marginBottom: "213px", marginTop: "69px" }}>
                <MediumButton
                  career={true}
                  label="REGISTER NOW"
                  fill="#fff"
                  textColor="#890295"
                />
              </div>
            </Link>
          ) : (
            <div
              style={{ marginBottom: "213px", marginTop: "69px" }}
              onClick={handleButton}
            >
              <MediumButton
                career={true}
                label="REGISTER NOW"
                fill="#fff"
                textColor="#890295"
              />
            </div>
          )}
        </Container>
      </SectionContainer>

      <hr className="line" />
      <SectionContainer>
        <Map />
        <hr className="line-style-testprep" />
        <SmallPage countryPage={true} />

        <Form
          modal={modalOpen}
          toggle={toggleModal}
          heading="Fill in the details below to confirm your registration for the event."
          description=" "
          additionalField={false}
          preferredStudylevel={true}
          closingMessage="FOR REGSTERING! WE LOOK FORWARD TO SEEING YOU AT THE EVENT"
          closingDesc=" "
          isEvent={true}
        />
      </SectionContainer>
    </>
  );
};

export default EventDetail;
